import { createSelector } from 'reselect';
import { errorsToTouch } from '@synergy/utils';

import { AppState } from '../../../../../../store/models/app-state';
import { ExternalCustomerMapping } from '../../../../components/external-customer-mapping/external-customer-mapping';

const getCustomerDetail = (state: AppState) => state.contactsAndOrganizations.customers.customerDetail;

export const supplierExternalCustomerMappingSelector = createSelector(
    getCustomerDetail,
    state => state.supplierExternalCustomerMappings
);

export const externalCustomerMappingSelector = createSelector(supplierExternalCustomerMappingSelector, state => {
    return {
        formValues: {
            mappings: [...state.externalCustomerMapping] as ExternalCustomerMapping[],
        },
        errors: { ...state.errors },
        touched: errorsToTouch(state.errors),
    };
});

/** What the tab compares against to decide whether anything is unsaved. */
export const externalCustomerMappingBaselineSelector = createSelector(supplierExternalCustomerMappingSelector, state =>
    state.baseline ? { mappings: [...state.baseline] as ExternalCustomerMapping[] } : undefined
);
